/**
 * 屏幕断点常量（与 Tailwind 配置与 ScreenType 一致）
 */
export const BREAKPOINTS = {
  SM_MAX: 767,
  MD_MIN: 768, // 用于瀑布流 breakpoint
  MD_MAX: 1023,
  LG_MIN: 1024, // 用于瀑布流 breakpoint
  LG_MAX: 1439,
  DEFAULT_MIN: 1440,
  XL_MIN: 1624,
  FHD_MIN: 1920,
  QHD_MIN: 2160,
  QHD_PLUS_MIN: 2560,
} as const;

export type Breakpoints = typeof BREAKPOINTS;
